export enum FormFieldType {
  FullName = 1,
  Phone = 2,
  City = 3,
  OpenText = 4,
  YesOrNo = 5,
  Dropdown = 6,
}
export interface FormField {
  id: string;
  fieldType: FormFieldType;
  controlType: "phone" | "text" | "textarea" | "dropdown" | "radio_group";
  label?: string;
  placeholder: string;
  prefillValue: string;
  helperText: string;
  isRequired: boolean;
  displayOrder: number;
  isMultiSelect: boolean;
  optionItems: { id: string; label: string }[];
}
export interface Camp {
  id: string;
  title: string;
  slug: string | null;
  imageUrl: string;
  coverImageUrl: string;
  summary: string;
  highlights: string[];
  contentBlocks: { title: string; content: string }[];
  fields: FormField[];
  instructors?: Instructor[];
  primaryActionText: string;
  primaryActionUrl: string;
  consentText: string;
  consentUrl: string;
  consentLinkText: string;
  submitButtonText: string;
}

export interface Instructor {
  id: string;
  name: string;
  title: string;
  image: string;
}

export interface Ebook {
  id: string;
  name: string;
  slug: string;
  summary: string;
  description: string;
  file: string;
  image: string;
}
